import clsx from 'clsx'
import React from 'react'

function Table({ className, head, children, style }) {
    const tableCss = (theme) => {
        const radius = theme.borderRadius?.xl
        const white = theme.colors?.white
        const primary = theme.colors?.primary
        const lighterGray = theme.colors?.lighterGray
        return `
            background: ${white};
            border-radius: ${radius};
            th {
                padding: 15px;
                text-align: center;
            }
            td {
                padding: 15px 5px 15px 5px;
                text-align: center;
            }
            th:first-of-type {
                border-top-right-radius: ${radius};
                text-align: start;
                padding-right: 1.5rem;

            }
            th {
                position: relative;
            }
            th:last-child {
                border-top-left-radius: ${radius};
            }
            thead {
                color: ${primary};
                outline-offset: -1px;
                border-top-left-radius: ${radius};
                border-top-right-radius: ${radius};
                outline: 1px solid ${lighterGray};
                // background-color: ${white};

            }
            tbody {
                outline: 1px solid ${lighterGray};
                outline-offset: -1px;
                border-bottom-left-radius: ${radius};
                border-bottom-right-radius: ${radius};
                -moz-outline-radius: ${radius};
            }
            tr {
                border-bottom: 1px solid ${lighterGray};
            }
            tr:last-child {
                border-bottom: none;
            }
            tr:last-child {
                td:first-of-type {
                    border-bottom-right-radius: ${radius};
                }
                td:last-child {
                    border-bottom-left-radius: ${radius};
                }
            }
            ${style}
       
        `
    }

    return (
        <div className={clsx('w-full', className)}>
            <table className="w-full" css={tableCss}>
                <thead>
                    <tr>
                        {head.map((item, idx) => (
                            <th key={idx}>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>{children}</tbody>
            </table>
        </div>
    )
}

export default Table
